import { type CategoryTree } from '@/shared/category/type';
import { SchoolMapper } from '@/shared/category/util/SchoolMapper';
import { isAllGrades } from '@/views/build/util';

export const isShowSemester = (schoolName: string, countryCode: string) =>
  ['MIDDLE', 'HIGH', 'PRIMARY'].includes(schoolName) && countryCode === 'KR';

export const makeSemesterNodes = (grade?: CategoryTree): FilterNode[] => {
  return [1, 2, SchoolMapper.COMMON_ID].map(semester => ({
    categoryGroupId: '1',
    name: semester === SchoolMapper.COMMON_ID ? 'COMMON' : semester.toString(),
    categoryTreeId: semester.toString(),
    value: semester.toString(),
    ancestors: grade ? [...(grade.ancestors ?? []), grade?.categoryTreeId] : [],
    type: 'SEMESTER' as const,
    children: [],
    order: 0,
  }));
};

/**
 *  한국일 경우 자체 학기까지 붙여주는 트리구조를 만들어줍니다.
 * */
export const joinSemesterTree = (
  data: CategoryTree,
  countryCode: string,
): CategoryTree => {
  data.children.forEach(schoolInfo => {
    schoolInfo.children.map(grade => {
      grade.children =
        isShowSemester(schoolInfo.name, countryCode) &&
        !isAllGrades(grade.categoryGroupId)
          ? makeSemesterNodes(grade)
          : [];
    });
  });

  return data;
};

type FilterNode = CategoryTree & { value: string };
